import axios from "axios";
import NProgress from "nprogress";
import router from "@/router";
import "nprogress/nprogress.css";
import { hex_sha1_utf_8 } from "@/utils/sha1";

NProgress.configure({ showSpinner: false });

const date = Date.now();

const service = axios.create({
  baseURL: process.env.VUE_APP_APITAAS,
  withCredentials: true,
  headers: {
    Referer: window.location.href,
    systemId: 20,
    platformType: "SC",
    "Cache-Control": "no-cache",
    AppCode: process.env.VUE_APP_APPLICATION_CODE,
    AppTimestamp: date
  }
});

service.interceptors.request.use(config => {
  NProgress.start();

  let arg = `${process.env.VUE_APP_APPLICATION_CODE}${
    process.env.VUE_APP_APPLICATION_SECRET_KEY
  }${date}`;
  if (config.data) {
    arg = `${arg}${JSON.stringify(config.data)}`;
  } else if (config.method == "post") {
    arg = JSON.stringify(`${arg}{}`);
  }
  config.headers.AppSign = hex_sha1_utf_8(arg);
  return config;
});

service.interceptors.response.use(
  response => {
    NProgress.done();

    const { status, data } = response;

    if (status === 403) {
      router.push("/403");
      return false;
    }

    if (status >= 404 && status < 422) {
      router.push("/404");
      return false;
    }

    if (status <= 504 && status >= 500) {
      router.push("/500");
      return false;
    }

    return data;
  },
  error => {
    // eslint-disable-next-line
    console.log(`接口信息：${error.msg}` || "系统繁忙");
    return Promise.reject(error);
  }
);

export default service;
